import { getTestIds } from '../../utils/TestIds';
export const GetMobileRichTextEditorTID = (parentTestId)=>getTestIds(parentTestId);
export const { MobileRichTextEditorTID } = GetMobileRichTextEditorTID();
